import { inject, Injectable } from '@angular/core';
import { Dialog2Service } from '../../../services/dialog2.service';
import { Observable, Subject } from 'rxjs';
import { Dialog2Type } from '../../../models/dialog/dialog2.model';

@Injectable()
export class CameraDialogClientService {

  //region INJECTIONS
  private dialog2Service: Dialog2Service = inject(Dialog2Service);
  //endregion

  //region FIELDS
  private resolver: Subject<File>;
  //endregion

  //region METHODS
  capture(): Observable<File> {
    if (!!this.resolver) {
      throw new Error('Camera dialog already in use!');
    }
    this.resolver = new Subject<File>();
    this.dialog2Service.openDialog(Dialog2Type.CAMERA);
    return this.resolver;
  }

  resolve(file: File | null): void {
    this.resolver.next(file);
    this.resolver.complete();
    this.resolver = null;
    this.dialog2Service.closeDialog(Dialog2Type.CAMERA);
  }
  //endregion
}
